import { decode } from './dataProps';

const decodeDataProps = <T>(rootElement: HTMLElement | null): T | undefined => {
    const encodedDataset = rootElement?.dataset.props;
    if (!encodedDataset) return undefined;
    const decodedDataset = decode(encodedDataset) as T;
    return decodedDataset;
};

export default decodeDataProps;
